import { Subject } from 'rxjs';

const subject = new Subject();

export const APIErrorService = {
    trowError: message => subject.next({ message }),
    getErrors: () => subject.asObservable(),
};